import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IAviso } from 'src/app/core/modules/sistema/models/IAviso.interface';
import { IHttpResponse } from 'src/app/core/models/IHttpResponse.interface';
import { ModuleBaseService } from 'src/app/core/services/base/module-service-base.class';
import { MODULOS } from 'src/app/core/constants/modulo.constant';

@Injectable({
  providedIn: 'root'
})
export class AvisoService extends ModuleBaseService {

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    const http = inject(HttpClient);
    const url = inject<string>('BASE_URL' as any);

    super(http, url, MODULOS.SISTEMA, 'Avisos');
  }

  public buscar(soloActivos = true): Observable<IHttpResponse<IAviso[]>> {
    return this.http.get<IHttpResponse<IAviso[]>>(
      `${this.baseApiUrl}/api/v1/${this.moduleName}/${this.resourceName}`,
      { params: { soloActivos } }
    );
  }
}
